import { MenuItem, Select } from '@mui/material';
interface Props {
	selectCountry: string;
	handleSelectCountry: (e: any) => void;
	isDisabled: boolean;
}
const SelectCountry = ({
	selectCountry,
	handleSelectCountry,
	isDisabled,
}: Props) => {
	const countries = ['India', 'Qatar', 'UAE'];

	return (
		<>
			<Select
				labelId='country-select-label'
				value={selectCountry}
				sx={{
					padding: '0px',
					fontSize: '12px',
				}}
				MenuProps={{
					PaperProps: {
						sx: {
							padding: '0px',
							fontSize: '12px',
						},
					},
				}}
				onChange={(e) => handleSelectCountry(e)}
				disabled={isDisabled}>
				<MenuItem value='India'>India</MenuItem>
				<MenuItem value='Qatar'>Qatar</MenuItem>
				<MenuItem value='UAE'>UAE</MenuItem>
			</Select>
		</>
	);
};
export default SelectCountry;
